import moment from 'moment';
import useSWR from 'swr';

const fetcher = (url: string) => fetch(url).then(res => res.json());

export default function SystemStatus({
    dev
}: {
    dev?: boolean
}) {
    const { data, error, isLoading } = useSWR(
        `${process.env.REACT_APP_BASE_API_URL.replace('/api', '')}/health/ready`,
        fetcher,
        {
            refreshInterval: dev ? 10000 : 30000, // 1 minute in milliseconds
            revalidateOnFocus: false, // Optional: don't recheck when window regains focus
            revalidateOnReconnect: true, // Recheck when internet reconnects
        }
    );

    // Don't show anything while loading initially
    if (isLoading) return null;

    // Determine status - show error if fetch failed OR if status is not 'ok'
    const isHealthy = !error && data?.status === 'ok';

    if (dev) {
        return (
            <div className="header-icons d-inline-block align-middle mr-4" data-tip={isHealthy ? 'System Online' : 'System Issues'}>
                <i className={`ml-4 mr-2 fad ${isHealthy ? 'fa-database text-success' : 'fa-triangle-exclamation text-danger'}`} style={{ fontSize: '24px' }}></i>
                <span>System Online {moment(data.timestamp).format('YYYY-MM-DD hh:mm:ss A')}</span>
            </div>
        )
    }

    return (
        <div className="status-indicator mx-auto">
            {isHealthy ? '✅ System Online' : '⚠️ System Issues'}
        </div>
    );
}